import { render, staticRenderFns } from "./purchaseOrderRecord.vue?vue&type=template&id=17047c13&scoped=true"
import script from "./purchaseOrderRecord.vue?vue&type=script&lang=js"
export * from "./purchaseOrderRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17047c13",
  null
  
)

export default component.exports